

import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import {Button} from 'reactstrap';
import { AiOutlinePrinter } from "react-icons/ai";
import LongPressComponent from '../../../../../components/longPress/LongPressComponent';
import SelectionView from '../../../../../components/selectionView/SelectionView'

var viewUtil = require('../../../../../utils/view/viewUtil');
var translator = require('../../../../../utils/translator/translator');
var controlSettingsUtils = require('../../../../../utils/domain/settings/controlSettingsUtils');
var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var salePrinter = require('../../../utils/salePrinter');

class PrintToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);
        this.onPrint = this.onPrint.bind(this);
        this.onPrintOptions = this.onPrintOptions.bind(this);

        this.state = {};
        this.state.showPrintOptionsDialogue = false;
    }

    render()
    {
        return (<>
                    <LongPressComponent style={{minWidth:'33.33%'}}
                                        onClick={this.onPrint}
                                        onLongPress={this.onPrintOptions}>
                        <Button className='btn-action' style={{fontSize:'2rem', minHeight:'8vh', minWidth:"100%", borderRadius: 0}}>
                            <AiOutlinePrinter/>
                        </Button>
                    </LongPressComponent>
                    {this.renderPrintOptionsDialogue()}
                </>)
    }

    onPrint()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        if (!controlSettingsUtils.getPrintDraftSaleReceipt())
        {
            if (!saleCommonUtility.isExistingSale(saleContext) || 
                saleContext.requirePublishing ||
                saleCommonUtility.isSaleHold(sale))
            {
                viewUtil.showErrorAlert(translator.getLabel("printing_is_disabled_as_sale_has_not_been_yet_sent_to_kitchen"));
                return;
            }
        }

        salePrinter.printSaleCustomerReceipt(sale, 1);
    }

    onPrintOptions()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        if (!saleCommonUtility.isExistingSale(saleContext) || 
            saleContext.requirePublishing ||
            saleCommonUtility.isSaleHold(sale))
        {
            this.onPrint();
            return;
        }

        this.state.showPrintOptionsDialogue = true;
        this.setState({});
    }

    renderPrintOptionsDialogue()
    {
        if (!this.state.showPrintOptionsDialogue)
            return null;

        let selections = [];

        let selection = {};
        selection.caption = translator.getLabel("customer_receipt_printing");
        selection.id = "1";
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("kitchen_printing");
        selection.id = "2";
        selections.push(selection);

        
        

        return <SelectionView selections={selections} caption={translator.getLabel("options")}
                                onClose={()=>
                                {
                                    this.state.showPrintOptionsDialogue = false;
                                    this.setState({});
                                }}
                                onSelection={(selection)=>
                                {
                                    this.state.showPrintOptionsDialogue = false;
                                    this.setState({});

                                    if (selection.id == "1")
                                        this.onPrint();
                                    else
                                        salePrinter.printSaleKitchenTicket(this.props.saleContext.sale);
                                }}
                />
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(PrintToolbarButton)
